/**
 * Sör típusa   * SPONTANEOUSLY_FERMENTED - Spontán erjesztésű   * TOP_FERMENTED - Felső erjesztésű   * BOTTOM_FERMENTED - Alsó erjesztésű   * HYBRID - Hibrid - különleges eljárással készülő
 */
export type BeerType =
  | 'SPONTANEOUSLY_FERMENTED'
  | 'TOP_FERMENTED'
  | 'BOTTOM_FERMENTED'
  | 'HYBRID';

export const BeerType = {
  SpontaneouslyFermented: 'SPONTANEOUSLY_FERMENTED' as BeerType,
  TopFermented: 'TOP_FERMENTED' as BeerType,
  BottomFermented: 'BOTTOM_FERMENTED' as BeerType,
  Hybrid: 'HYBRID' as BeerType,
};
